import * as tslib_1 from "tslib";
import { TranslateService } from '@ngx-translate/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
var CustomMatPaginatorIntl = /** @class */ (function (_super) {
    tslib_1.__extends(CustomMatPaginatorIntl, _super);
    function CustomMatPaginatorIntl(translate) {
        var _this = _super.call(this) || this;
        _this.translate = translate;
        _this.rangeLabel = function (page, pageSize, length) {
            if (length === 0 || pageSize === 0) {
                return "0 " + _this.translate.instant('of') + " " + length;
            }
            length = Math.max(length, 0);
            var startIndex = page * pageSize;
            // If the start index exceeds the list length, do not try and fix the end index to the end.
            var endIndex = startIndex < length
                ? Math.min(startIndex + pageSize, length)
                : startIndex + pageSize;
            return startIndex + 1 + " - " + endIndex + " " + _this.translate.instant('of') + " " + length;
        }; // tslint:disable-line
        _this.translate.onLangChange.subscribe(function (e) {
            _this.getAndInitTranslations();
        });
        _this.getAndInitTranslations();
        return _this;
    }
    CustomMatPaginatorIntl.prototype.getAndInitTranslations = function () {
        var _this = this;
        this.translate
            .get(['items per page', 'next page', 'previous page'])
            .subscribe(function (translation) {
            _this.itemsPerPageLabel = translation['items per page'];
            _this.nextPageLabel = translation['next page'];
            _this.previousPageLabel = translation['previous page'];
            _this.getRangeLabel = _this.rangeLabel;
            _this.changes.next();
        });
    };
    CustomMatPaginatorIntl.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CustomMatPaginatorIntl_Factory() { return new CustomMatPaginatorIntl(i0.ɵɵinject(i1.TranslateService)); }, token: CustomMatPaginatorIntl, providedIn: "root" });
    return CustomMatPaginatorIntl;
}(MatPaginatorIntl));
export { CustomMatPaginatorIntl };
